import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

import { Providers } from './app/providers';
import { router } from './app/router';

// Self-hosted Geist, replacing `next/font`'s build-time subsetting. Fontsource
// ships the same variable faces and, like next/font, serves them from our own
// origin — an internal tool should not phone a font CDN on every load.
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';

import './app/globals.css';

/**
 * SPA entry point.
 *
 * No `<StrictMode>`, deliberately: the Next config carried `reactStrictMode:
 * false` for HeroUI v2 under React 19 (ADR-0009), and that constraint is about
 * the component library, not the framework — it survives the move intact. Revisit
 * when HeroUI is verified double-render-safe.
 */
const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
    <Providers>
        <RouterProvider router={router} />
    </Providers>,
);
